module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rules"
  }, [_c('h3', [_vm._v("Drinking Rules:")]), _vm._v(" "), _c('ul', _vm._l((_vm.rules), function(rule) {
    return _c('li', [_vm._v(_vm._s(rule))])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8a97e5aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DrinkingRules.vue
// module id = 42
// module chunks = 0